export default {
  title: "Администрирование",
  pageSubtitle: "Роли, пользователи и каталог библиотеки.",
  overview: {
    nav: "Обзор",
    welcome: "Здравствуйте, {{name}}",
    welcomeHint: "Это кабинет каталогизации. Записи каталога, ошибки, словари, импорт и статистика.",
    servicesTitle: "Разделы каталога",
    catalogHint: "Сущности, слияние, словари и импорт каталога НБР",
    analyticsHint: "Счётчики сущностей и связей каталога",
    usersHint: "Учётные записи и роли доступа",
    associationsHint: "Виды объединений и дерево союзов",
    auditHint: "Журнал действий и доменный аудит",
  },
  subtitles: {
    overview: "Записи каталога, ошибки, словари, импорт и статистика.",
    users: "Учётные записи и назначенные роли.",
    roles: "Роли доступа и их владельцы.",
    associations: "Виды объединений и дерево союзов.",
    audit: "Журнал действий в каталоге.",
    auditEvents: "Решения по мероприятиям.",
    auditDeposits: "Решения по депозитам.",
    entities: "Лица, произведения, издания и другие сущности LRM.",
    nbrOld: "Живой просмотр прежнего каталога. Записи не сохраняются.",
    entityEdit: "Карточка сущности каталога.",
    merge: "Объединение дублей в одну запись.",
    errors: "Сообщения читателей об ошибках в карточках.",
    dictionaries: "Типы сущностей, связей и ролей.",
    import: "Загрузка записей MARC / RUSMARC.",
    creative: "Справочник творческих специальностей.",
  },
  overviewStats: {
    entitiesTitle: "Каталог",
    entitiesHint: "Сущности LRM в каталоге НБР.",
    entitiesTotal: "Всего записей",
    errorsTitle: "Ошибки",
    errorsHint: "Новые сообщения читателей о неточностях.",
    errorsNew: "Новых",
  },
  overviewServices: {
    entities: "Создание и правка записей каталога",
    merge: "Объединение дублирующихся записей",
    errors: "Разбор сообщений об ошибках",
    dictionaries: "Типы сущностей, связей и ролей",
    import: "Загрузка MARC / RUSMARC",
  },
  nav: {
    overview: "Обзор",
    users: "Пользователи",
    entities: "Сущности",
    nbrOld: "НБР_OLD",
    merge: "Слияние",
    errors: "Ошибки",
    dictionaries: "Словари",
    import: "Импорт",
    audit: "Аудит",
    associations: "Союзы",
    roles: "Роли",
    creative: "Самоопределение",
    auditEvents: "Аудит мероприятий",
    auditDeposits: "Аудит депозитов",
  },
  entities: "Каталог сущностей",
  nbrOld: {
    hint: "Введите запрос",
    year: "Год",
    brief: "Исходная строка",
    open: "Открыть запись",
    yearFrom: "Год от",
    yearTo: "до",
    yearsHint: "Один год можно указать в любом поле. Диапазон не больше 50 лет.",
    isbnHint: "Поиск по ISBN: в каталоге дефисы записаны по-разному, поэтому совпадение находится не всегда.",
    roles: "Роли в изданиях",
    roleAuthor: "автор",
    rolesEmpty: "В сводном каталоге нет изданий с этим заголовком",
    about: "Издания о лице",
    aboutEmpty: "Нет",
    editions_one: "{{count}} издание",
    editions_few: "{{count}} издания",
    editions_many: "{{count}} изданий",
    editions_other: "{{count}} издания",
    suggestions: "Подсказки",
    resultsFor: "Издания: {{label}}",
    reset: "Сбросить",
  },
  createEntity: "Новая сущность",
  createMenu: "Создать",
  editEntity: "Редактирование",
  type: "Тип",
  label: "Метка",
  attributesJson: "Атрибуты (JSON)",
  invalidJson: "Некорректный JSON",
  nomens: "Номены",
  identifiers: "Идентификаторы",
  relations: "Связи",
  addNomen: "Добавить номен",
  addIdentifier: "Добавить идентификатор",
  addRelation: "Добавить связь",
  text: "Текст",
  kind: "Вид",
  scheme: "Схема",
  value: "Значение",
  predicate: "Предикат",
  subject: "Субъект",
  object: "Объект",
  role: "Роль",
  merge: "Слияние дублей",
  mergeTarget: "Целевая запись",
  mergeSources: "Источники (через запятую, UUID)",
  mergeAction: "Объединить",
  mergeDone: "Записи объединены",
  duplicates: "Кандидаты дублей",
  similarity: "Сходство",
  errorReports: "Сообщения об ошибках",
  status: "Статус",
  resolution: "Резолюция",
  dictionaries: "Словари модели",
  version: "Версия",
  importTitle: "Импорт Excel",
  chooseFile: "Файл .xlsx",
  dryRun: "Пробный прогон (без записи)",
  startImport: "Запустить",
  jobs: "Задания",
  reindex: "Переиндексировать поиск",
  reindexDone: "Переиндексация поставлена в очередь",
  audit: "Журнал аудита",
  actor: "Актор",
  action: "Действие",
  entityId: "ID сущности",
  confirmDelete: "Удалить запись безвозвратно?",
  constructor: {
    newPerson: "Новый автор",
    newEdition: "Новое издание",
    details: "Сведения",
    preview: "Превью",
    lang: "Язык",
    unique: "уникальный",
    choose: "Выберите",
    noAttributes: "Для этого типа нет дополнительных полей.",
    similarFound: "Похожие записи уже есть в каталоге. Откройте существующую, если это тот же объект.",
    identifierTaken: "Идентификатор уже занят. Откройте существующую запись — создать дубль нельзя.",
    nameRequired: "Укажите хотя бы одно имя.",
    titleRequired: "Укажите заглавие издания.",
    authorRequired: "Добавьте хотя бы одного автора.",
    workRequired: "Выберите существующее произведение.",
    expressionRequired: "Выберите существующее выражение.",
    graphLabel: "Связи сущности",
    removeRelation: "Удалить связь",
    createRelated: "Создать связанную",
    relatedName: "Имя новой связанной записи",
    confirmCreateRelated: "Добавить как новую",
    wizardLabel: "Шаги создания персоны",
    wizardEditionLabel: "Шаги создания издания",
    back: "Назад",
    next: "Далее",
    kindPreferred: "предпочтительное",
    kindVariant: "вариант",
    useExisting: "Взять существующую",
    createNew: "Создать новую",
    publisherNone: "Не указывать",
    publisherName: "Название издателя",
    authorName: "Имя нового автора",
    addAuthor: "Добавить автора",
    roleAut: "автор",
    steps: {
      names: "Имена",
      details: "Сведения",
      identifiers: "Идентификаторы",
      relations: "Связи",
      preview: "Проверка",
    },
    editionSteps: {
      manifestation: "Издание",
      work: "Произведение",
      expression: "Выражение",
      authors: "Авторы",
      publisher: "Издатель",
      preview: "Проверка",
    },
    enums: {
      gender: {
        male: "мужской",
        female: "женский",
        unknown: "не указан",
      },
    },
  },
  associations: {
    title: "Ассоциации",
    kinds: "Виды групп",
    groups: "Группы",
    emptyKinds: "Виды групп не найдены.",
    emptyGroups: "Группы не найдены.",
    loadFailed: "Не удалось загрузить ассоциации.",
    requiresApproval: "Требует одобрения",
  },
  domainAudit: {
    eventsTitle: "Аудит мероприятий",
    depositsTitle: "Аудит депозитов",
    empty: "Записей нет.",
    loadFailed: "Не удалось загрузить аудит.",
    entity: "Сущность",
    from: "Было",
    to: "Стало",
    note: "Заметка",
    when: "Когда",
  },
  users: {
    title: "Пользователи",
    account: "Учётная запись",
    search: "Поиск среди загруженных пользователей",
    filterStatus: "Фильтр по статусу",
    status: "Статус",
    rolesTitle: "Кабинеты",
    caption: "Локальные учётные записи и доступы к кабинетам",
    roleRequired: "Выберите хотя бы один кабинет",
    updateFailed: "Не удалось обновить учётную запись.",
    loadFailed: "Не удалось загрузить пользователей.",
    statuses: {
      active: "Активен",
      blocked: "Заблокирован",
    },
    roles: {
      reader: "Читатель",
      librarian: "Библиотекарь",
      publisher: "Издатель",
      analyst: "Аналитик",
      admin: "Администратор",
    },
    cabinets: {
      reader: "Читатель",
      writer: "Писатель",
      union: "Администратор союза",
      organizer: "Организатор мероприятий",
      catalog: "Библиотекарь",
      administrator: "Администратор",
      readerLocked: "Базовый доступ нельзя снять",
    },
  },
  creative: {
    title: "Самоопределение",
    empty: "Справочник пуст.",
    loadFailed: "Не удалось загрузить каталог самоопределения.",
    direction: "Направление",
    subdirection: "Поднаправление",
    role: "Роль",
  },
}
